import { NotificationPayload, NotificationStatus } from '../../../types';

export const NOTIFICATION_ACTIONS = {
  READ: 'READ',
  UNREAD: 'UNREAD',
  ACCEPT: 'ACCEPT',
  REJECT: 'REJECT',
} as const;

export type NotificationAction = (typeof NOTIFICATION_ACTIONS)[keyof typeof NOTIFICATION_ACTIONS];

export const NOTIFICATION_EVENTS = {
  DATA_REFRESH: 'notification:data_refresh',
  VIEW_REFRESH: 'notification:view_refresh',
} as const;

export type NotificationEventName = (typeof NOTIFICATION_EVENTS)[keyof typeof NOTIFICATION_EVENTS];

export type NotificationWorkflowItem = {
  notificationId: number;
  userNotificationId: number;
  status: NotificationStatus;
  type: string | null;
  payload: NotificationPayload | null;
  userId: number | null;
  actingUserId?: number | null;
};

export type NotificationWorkflowContext = {
  item: NotificationWorkflowItem;
  action: NotificationAction;
  nextStatus: NotificationStatus;
};

export type NotificationStrategy = {
  accept: (ctx: NotificationWorkflowContext) => Promise<void>;
  reject: (ctx: NotificationWorkflowContext) => Promise<void>;
};

export type NotificationStrategyMap = Record<string, NotificationStrategy>;

export type NotificationWorkflowResult =
  | {
      success: true;
      status: NotificationStatus;
    }
  | {
      success: false;
      error: string;
    };
